<template>
  <div class="menus hidden-sm-and-down">
    <template v-for="(item, i) in items">
      <span
        v-if="!item.items"
        :key="i"
        role="button"
        class="menu-item"
        @click="handleMenuClick(item)"
      >
        {{ $t(item.title) }}
      </span>
      <v-menu
        v-else
        offset-y
        transition="slide-y-transition"
        content-class="menu-content primary"
        :key="`menu-item-${i}`"
        :close-on-content-click="false"
        open-on-hover
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <span role="button" class="menu-item" v-bind="attrs" v-on="on">
            {{ $t(item.title) }}
          </span>
        </template>
        <v-list dense nav min-width="8rem">
          <template v-for="(subItem, index) in item.items">
            <v-list-item
              v-if="!subItem.permission || hasPermission(subItem.permission)"
              :key="`subItem-${index}`"
              @click="handleMenuClick(subItem)"
            >
              <v-list-item-title class="menu-subitem">
                {{ $t(subItem.title) }}
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Menu from '@/api/menu'
import { hasPermission, setVeeLocale } from '@/utils'

export default {
  name: 'AppMenu',
  data: () => ({
    openMenu: false
  }),
  created() {
    this.setIdiom(this.idiom)
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('account', ['account']),
    ...mapState('language', ['languages', 'idiom']),
    twofactor() {
      return this.user?.twofactor_habilitated
    },
    locales() {
      return this.languages
        .filter(item => item.code !== this.idiom.code)
        .map(item => {
          return {
            ...item,
            title: item.name,
            click: item => this.handleLocale(item)
          }
        })
    },
    items() {
      const profile = {
        name: 'profile',
        title: this.firstName + ' ' + this.lastName,
        public: true,
        items: [
          {
            name: 'twoFator',
            title: this.twofactor
              ? 'twofactor_reset_label'
              : 'twofactor_menu_install',
            component: 'Delete'
          }
        ]
      }

      const language = {
        name: 'language',
        title: this.idiom.name,
        items: this.locales,
        public: true
      }

      const logout = {
        name: 'logout',
        title: 'menu_logout',
        public: true,
        click: async () => {
          try {
            await this.logout()
          } catch (error) {
            console.log(error)
          } finally {
            if (process.env.VUE_APP_REDIRECT_URL) {
              window.open(process.env.VUE_APP_REDIRECT_URL, '_self')
            } else {
              this.$router.push({ name: 'Login' })
            }
          }
        }
      }

      const elements = [...Menu]

      if (this.user) {
        elements.push(profile)
        elements.push(language)
      }
      elements.push(logout)

      return this.account ? elements : elements.filter(item => item.public)
    },
    firstName() {
      return this.user?.first_name.substring(0, 30)
    },
    lastName() {
      return this.user?.last_name.substring(0, 30)
    }
  },
  methods: {
    ...mapActions('language', ['setIdiom']),
    ...mapActions(['setLoading']),
    ...mapActions('auth', ['logout']),
    hasPermission(permission) {
      return hasPermission(this.user, permission)
    },
    handleMenuClick(item) {
      this.openMenu = false
      if (item.click) {
        item.click(item)
      } else {
        this.$router.push({ name: item.component })
      }
    },
    handleLocale(item) {
      this.setLoading(true)
      try {
        this.setIdiom(item)
        setVeeLocale(item.code)
      } catch (error) {
        console.log(error)
      } finally {
        this.setLoading(false)
      }
    }
  }
}
</script>
<style lang="sass">
.menu-content
  margin-top: -1px
  border-top: 4px solid #00559e
  border-top-left-radius: 0 !important
  border-top-right-radius: 0 !important
  &.submenu
    border-top: none


.menus
  display: flex
  flex-direction: row
  justify-content: space-between
  align-content: flex-end
  align-items: flex-end

.menu-subitem
  font-size: 12px !important

.menu-item
  color: #F4F4F4 !important
  font-size: 14px
  text-decoration: none
  margin-left: 25px
  margin-right: 25px
  //min-height: 50px
  min-width: 40px
  margin-bottom: 0
  //padding-top: 44px
  //padding-bottom: 8px
  &:hover
    color: white
  &:last-of-type
    margin-right: 0

.list_color
  color: #686f8d !important
</style>
